// Undo a "please wait" state when the browser restores this page from its
// back/forward cache.
//
// Every step of the funnel disables its submit button and reveals a spinner
// before navigating on (step1's "Förbereder din bokning...", step2's
// Fortsätt, step3's Gå till betalning, the branded-fares Fortsätt, the
// front-page search overlay, step4's payment forms). Those states are
// deliberately left up through the navigation so the page doesn't flash back
// to an idle form as it unloads.
//
// Pressing Back then hands the page back exactly as it was left -- button
// still disabled, spinner still spinning -- because a bfcache restore is not
// a fresh load: the document was frozen, not torn down and re-parsed. No
// Stimulus lifecycle callback runs either (the controller was never
// disconnected), so nothing clears it and the user is stuck on a dead
// button with no way forward short of reloading by hand.
//
// `pageshow` with event.persisted is the one signal that distinguishes a
// restore from a normal load. A browser that declines to bfcache the page
// re-parses it instead, so its DOM is already idle and this never fires --
// which is why the callback only runs for persisted restores rather than on
// every pageshow.
//
// Returns the teardown function; call it from disconnect().
export function resetOnBfcacheRestore(reset) {
  const handler = (event) => {
    if (event.persisted) reset();
  };
  window.addEventListener("pageshow", handler);
  return () => window.removeEventListener("pageshow", handler);
}
